import { ResponsiveContainer, PieChart, Pie, Tooltip } from 'recharts';
import useCharts from '../../Hooks/useCharts';

const FirstChart = () => {
     const [charts, setCharts] = useCharts()
     return (
          <div>
               <main style={{width: '100%', height: 300, marginTop: 200}}>
                    <ResponsiveContainer>
                         <PieChart>
                              <Tooltip />
                              <Pie dataKey="revenue" data={charts} fill="#A17544" label />
                         </PieChart>
                    </ResponsiveContainer>
               </main>
          </div>
     );
};

export default FirstChart;